export default {
  en: {
    'bundles-polish-sku-components.polish-sku-list-item.duplicate-sku':
      'Duplicate SKU/Product codes are not allowed.',
    'bundles-polish-sku-components.polish-sku-list-item.sku-number.placeholder': 'SKU/Product Code',
    'bundles-polish-sku-components.polish-sku-list-item.tele.label':
      'Telecommunications, broadcasting & electronic services(EE)',
    'bundles-polish-sku-components.polish-sku-list-item.tele.true': 'Yes',
    'bundles-polish-sku-components.polish-sku-list-item.tele.false': 'No',
  },
};
